import { useEffect } from "react";
import { Alert, AlertColor } from "@mui/material";

import localisations from "domains/allocations/localisation";
import { useGetProductPartitionManagedStatus } from "domains/allocations/services/use-allocation-api";

interface IManagedProductStatusProps {
    productId: number | null;
    forceRefresh: boolean;
    showUnmanagedProduct?: boolean;
    onLoaded?: (status: boolean) => void;
    formatMessage?: (status: boolean) => string;
}

const InnerManagedProductStatus = (props: IManagedProductStatusProps) => {
    const { loading, data, error, refresh } = useGetProductPartitionManagedStatus(props.productId as number);
    const { forceRefresh, onLoaded, formatMessage } = props;

    const defaultFormatMessage = (status: boolean): string => status ? localisations.managedProductStatus.managed : localisations.managedProductStatus.unmanaged;
    const messageToDisplay = formatMessage || defaultFormatMessage;
    const statusSeverity = (status: boolean): AlertColor => (status ? "success" : "info");

    useEffect(() => {
        if (forceRefresh && !loading) {
            refresh();
        }
    }, [refresh, forceRefresh, loading]);

    useEffect(() => {
        if (!loading && !error && data) {
            if (onLoaded) {
                onLoaded(data.ledgerManaged);
            }
        }
    }, [loading, data, error, onLoaded]);

    return (
        <>
            {!loading && data && (props.showUnmanagedProduct ? !data.ledgerManaged : true) && (
                <Alert severity={statusSeverity(data.ledgerManaged)}>{messageToDisplay(data.ledgerManaged)}</Alert>
            )}
        </>
    );
};

const ManagedProductStatus = (props: IManagedProductStatusProps) => {
    if (!props.productId) return null;

    return (
        <InnerManagedProductStatus
            showUnmanagedProduct={props.showUnmanagedProduct}
            productId={props.productId}
            forceRefresh={props.forceRefresh}
            onLoaded={props.onLoaded}
            formatMessage={props.formatMessage}
        ></InnerManagedProductStatus>
    );
};

export default ManagedProductStatus;
